export default __webpack_public_path__ + "static/home-four-newsletter-bg-169a4df6608ad0a5b0fa7e1538070b38.jpg";